import FiscalYearAddPage from './FiscalYearAddPage';

export default FiscalYearAddPage;
